<div class="flow-item">
  <div class="icon-container">
    @if (icon !== '') {
      <ion-icon class="main-icon" [icon]="icon"></ion-icon>
    }
  </div>

  <div class="content-container">
    <ng-content select="app-avatar"></ng-content>
    <ng-content></ng-content>
  </div>

  @if (detailIcon) {
    <div class="detail-icon-container">
      <ion-icon class="detail-icon" [icon]="endIcon"></ion-icon>
    </div>
  }
</div>
